module.exports = __webpack_public_path__ + "img/introOne.78be6f67.png";